
export function handleSuccess(message: any, enqueueSnackbar: any) {
    if(message) {
        enqueueSnackbar(message, {variant: 'success', autoHideDuration: 5000})
    }
}
